<template>
  <Modal
      v-model="_value"
      width="500"
      title="属实风险事件处理"
      @on-visible-change="visibleChange"
      ok-text="确认处理"
      @on-ok="onOk"
      cancel-text="关闭">
    <Form :model="gdDlysjgTrueHazardEvent" style="display: inline;">
      <FormItem prop="state">
        <label style="display: inline-block; width: 60px;">状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="gdDlysjgTrueHazardEvent.processState">
          <Option v-for="item in state" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result">
        <label style="display: inline-block; width: 60px;">处理结果</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="gdDlysjgTrueHazardEvent.processRemark" placeholder="处理结果">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'processtruehazardeventmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        state: [
          {label:'未处理', value:1},
          {label:'已处理', value:3}
        ],
        gdDlysjgTrueHazardEvent: {
          id: null,
          processState:1,
          processRemark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'GdDlysjgTrueHazardEventServ_AddProcessRemark',
        'GdDlysjgTrueHazardEventServ_GetDetail'
      ]),
      onOk() {
        console.log('onOk')
        this.$Modal.confirm({
          title: '确认处理',
          content: '<p>确认处理</p>',
          onOk: () => {
              store.dispatch('GdDlysjgTrueHazardEventServ_AddProcessRemark', {
                params: this.gdDlysjgTrueHazardEvent
              }).then(() => {
                this.$Message.success('处理成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.gdDlysjgTrueHazardEvent.id = null
          this.gdDlysjgTrueHazardEvent.processState = 1
          this.gdDlysjgTrueHazardEvent.processRemark = null
          let id = this._initValue
          if (id) {
              store.dispatch('GdDlysjgTrueHazardEventServ_GetDetail', {
                params: {id: this._initValue}
              }).then(() => {
                this.gdDlysjgTrueHazardEvent = store.getters.get_GdDlysjgTrueHazardEvent_GetDetailResult
              }).catch(err => {
                this.$Message.error(err)
              })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
